import { useTranslation } from "react-i18next";

import { GqlProtocolVisit } from "~/__generated__";

import { ProtocolVisitCondition } from "../../types/ProtocolVisitCondition";
import ConditionEditorDate from "./ConditionEditorDate";
import ConditionEditorLogical from "./ConditionEditorLogical";
import ConditionEditorOtherVisit from "./ConditionEditorOtherVisit";

type Props = {
    allVisits: GqlProtocolVisit[];
    condition: ProtocolVisitCondition;
    onChange: (condition?: ProtocolVisitCondition) => void;
};

export default function VisitConditionTypeSwitch({ allVisits, condition, onChange }: Props) {
    const { t } = useTranslation("protocol");

    switch (condition?.type) {
        case "and":
        case "or":
            return <ConditionEditorLogical allVisits={allVisits} logicalCondition={condition} onChange={onChange} />;
        case "beforeVisit":
        case "afterVisit":
            return <ConditionEditorOtherVisit allVisits={allVisits} condition={condition} onChange={onChange} />;
        case "minDate":
            return (
                <ConditionEditorDate
                    label={t("protocolVisitConditionsEditor.labelMinDate")}
                    condition={condition}
                    onChange={onChange}
                />
            );
        case "maxDate":
            return (
                <ConditionEditorDate
                    label={t("protocolVisitConditionsEditor.labelMaxDate")}
                    condition={condition}
                    onChange={onChange}
                />
            );
        case undefined:
            return undefined;
    }
}
